/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */

export function isPortraitMode() {
  const isPortrait = window.innerWidth / window.innerHeight < 1;
  return isPortrait;
}

export function getContentHeight() {
  const videoContainerHeight = document.getElementById("video-container").offsetHeight;
  /*
  purpose: calculating the height to display menu
  if (portrait mode == true)
    menu height = view port height - header height - video element height - footer height - category menu height - some margins
  else
       menu height = 1600px - same stuff
  */
  const NewMenuHeight = isPortraitMode()
    ? `calc(100vh - 49px - 25px - ${videoContainerHeight}px - 32px - 16px - 125px + 70px )`
    : `calc(1600px - 49px - 25px - ${videoContainerHeight}px - 32px - 16px - 125px - 5px )`;
  console.log("menu height", NewMenuHeight);
  return NewMenuHeight;
}

export function getSessionCookie(session) {
  localStorage.setItem(`SessionCookie`, session);
}

export function setSessionCookie() {
  localStorage.getItem(`SessionCookie`);
}
